import Decimal from 'decimal.js';

const defaultOptions = { rounding: Decimal.ROUND_HALF_UP };

export const subtract = (minuend, subtrahend, options = defaultOptions) => {
  minuend = minuend || 0;
  subtrahend = subtrahend || 0;

  try {
    const result = Decimal(minuend).minus(subtrahend).toDecimalPlaces(2, options.rounding);

    return Number(result);
  } catch (err) {
    return null;
  }
};

export const addition = (number, summand, options = defaultOptions) => {
  number = number || 0;
  summand = summand || 0;

  try {
    const result = Decimal(number).plus(summand).toDecimalPlaces(2, options.rounding);

    return Number(result);
  } catch (err) {
    return null;
  }
};

export const multiply = (number, multiplier, options = defaultOptions) => {
  number = number || 0;
  multiplier = multiplier || 0;

  try {
    const result = Decimal.mul(number, multiplier).toDecimalPlaces(2, options.rounding);

    return Number(result);
  } catch (err) {
    return null;
  }
};

export const divide = (dividend, divisor, options = defaultOptions) => {
  dividend = dividend || 0;
  divisor = divisor || 0;

  try {
    const result = Decimal(dividend).div(divisor).toDecimalPlaces(4, options.rounding);

    return Number(result);
  } catch (err) {
    return null;
  }
};

export const isLessThanZero = (number) => {
  number = number || 0;

  return Decimal(number).lessThan(0);
};

export const round = (number, options = defaultOptions) => {
  number = number || 0;

  return Number(Decimal(number).toDecimalPlaces(2, options.rounding));
};
